import { useEffect, useState } from 'react'
import useWindowDimensions from '../hooks/useWindowDimensions'

export const GridCardPlaceholder = () => {
  const IMG_RATIO_CONSTANT = 0.692

  const dimensions = useWindowDimensions()
  const [height, setHeight] = useState(null)

  // Calculates & keeps image placeholder height correct when resizing screen.
  useEffect(() => {
    setHeight(
      document.querySelector('.card-img-top').clientWidth * IMG_RATIO_CONSTANT
    )
  }, [dimensions])

  return (
    <div className="col-md-6 col-lg-3 col-6 my-3 align-item-stretch placeholder-glow">
      <div className="card-header-img position-relative placeholder-glow rounded-8">
        <div
          className="card-img-top placeholder rounded-8 bg-dark w-100"
          style={{ height }}
          id="card-img-top"
        />
      </div>
      <span className="placeholder col-7 rounded-8 bg-dark d-block my-2" />
      <span className="placeholder col-3 rounded-8 bg-dark d-block my-2" />
    </div>
  )
}
